module.exports = __webpack_public_path__ + "assets/img/deploy.6d5eeb45.svg";